import React from "react";
import { marqueeItems } from "../mock";

export default function Marquee() {
  const loop = [...marqueeItems, ...marqueeItems];
  return (
    <section className="py-10 bg-[#122b45] overflow-hidden">
      <div className="flex marquee-track gap-12 whitespace-nowrap">
        {loop.map((m, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="font-serif text-3xl md:text-5xl text-white tracking-tight">{m}</span>
            <span className="text-[#ee6c4d] text-3xl md:text-4xl">✿</span>
          </div>
        ))}
      </div>
    </section>
  );
}
